// production
// export const BASE_URL="https://aynnaka.herokuapp.com" process.env.REACT_APP_HOST ||
// Dev and test
// dev
export const BASE_URL = process.env.REACT_APP_HOST || "http://127.0.0.1:8000"

//prod

//export const BASE_URL = process.env.REACT_APP_HOST 
